import { Cover } from 'types/cover';
import { InterestedPartyUI } from 'types/policy';
import { RiskClassCode } from 'types/risk';

import { getInterestedPartiesByCover } from './getInterestedPartiesByCover';

const onlyUnique = (value: unknown, index: number, self: unknown[]) =>
  self.indexOf(value) === index;

const coverNotLiability = (value: Cover) => value !== Cover.Liability;

const coverToDropdownOption = (cover: Cover) => ({ id: cover, description: cover });

const toMulesoftInterestedParties = (interestedParties: string[]) =>
  interestedParties.map((name) => ({ name }));

const getInterestedPartiesFromRisk = (
  riskClassCode: RiskClassCode,
  interestedParties: InterestedPartyUI[]
) => {
  if (!interestedParties || interestedParties.length === 0) return [];

  const interestedPartiesByCover = getInterestedPartiesByCover(interestedParties);

  const getInterestedPartiesFromCovers = (covers: Cover[]) =>
    toMulesoftInterestedParties([
      ...covers
        .map((cover) => interestedPartiesByCover[cover])
        .flat()
        .filter((v) => v !== undefined),
    ]);

  switch (riskClassCode) {
    case RiskClassCode.Liability:
      return getInterestedPartiesFromCovers([Cover.Liability]);
    case RiskClassCode.BuildingAndContents:
      return getInterestedPartiesFromCovers([
        Cover.BuildingAndContents,
        Cover.BusinessInterruption,
      ]);
    case RiskClassCode.PortableItems:
      return getInterestedPartiesFromCovers([Cover.PortableItems, Cover.Breakdown]);
    case RiskClassCode.TheftMoneyGlass:
      return getInterestedPartiesFromCovers([Cover.Theft, Cover.Money, Cover.Glass]);
    case RiskClassCode.TaxAudit:
      return getInterestedPartiesFromCovers([Cover.TaxAudit]);
    default:
      throw new Error('Unexpected case');
  }
};

export const interestedPartyUtils = {
  onlyUnique,
  coverNotLiability,
  coverToDropdownOption,
  toMulesoftInterestedParties,
  getInterestedPartiesFromRisk,
};
